import { useEffect } from "react";
import CollapseTable from "../../components/tables/CollapseTable";
import { useFirebase } from "../../hooks/firebase/useFirebase";
import { ORDERS_API } from "../../constants/api";
import { orderBy, query } from "firebase/firestore";
import { kTimestamp } from "../../constants/strings";
import { useOrders } from "../../hooks/useOrders";
import {
  getDefaultLimit,
  usePagination,
} from "../../hooks/pagination/usePagination";

export const OrdersRegister = () => {
  const { ordersTableColumns, ordersTableData } = useOrders();

  const ordersRef = query(
    ORDERS_API,
    orderBy(kTimestamp, "desc"),
    getDefaultLimit()
  );

  const {
    fetchMore,
    paginatedList: orders,
    getList: getOrders,
    loading,
  } = usePagination(ordersRef);

  useEffect(() => {
    getOrders();
  }, []);

  return (
    <div>
      <CollapseTable
        loading={loading}
        columns={ordersTableColumns}
        rows={ordersTableData(orders)}
        fetchMore={fetchMore}
      />
    </div>
  );
};
